export default {
  online_payments_off:
    'Livrarea este activată, dar clienții nu o pot comanda: livrarea prin curier se plătește doar online, iar plățile online sunt dezactivate.',
  gateway_not_verified:
    'Livrarea este activată, dar clienții nu o pot comanda: livrarea prin curier se plătește doar online, iar plățile online sunt suspendate până când contul tău de plată este verificat.',
  stripe_processing_fee_missing:
    'Livrarea este activată, dar clienții nu o pot comanda: livrarea prin curier se plătește doar online, iar plățile online sunt suspendate până când partenerul tău stabilește comisionul de procesare.',
  turn_on_online_payments: 'Activează plățile online',
};
